import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_GENERIC_FILTER_PARAMS_QUERY = gql`
  query pagedGenericFilterParams($pager: PagerInputNew, $filters: GenericFilterParamFilterInput) {
    pagedGenericFilterParams(pager: $pager, filters: $filters) {
      total
      values {
        paramId
        paramCode
        paramName
      }
    }
  }
`;

export const GENERIC_FILTER_PARAMS_QUERY = gql`
  query genericFilterParams($context: String) {
    genericFilterParams(context: $context) {
      ...genericFilterParamItem
    }
  }
  ${Fragments.genericFilterParam}
`;

export const GENERIC_FILTER_OPERATORS_QUERY = gql`
  query genericFilterOperators {
    genericFilterOperators {
      operatorId
      operatorCode
      operatorName
      multipleSelection
    }
  }
`;

export const GENERIC_FILTER_PARAM_VALUES_QUERY = gql`
  query genericFilterParamValues($paramId: Int) {
    genericFilterParamValues(paramId: $paramId) {
      id
      name
    }
  }
`;

export const PAGED_GENERIC_FILTER_PARAM_VALUES_QUERY = gql`
  query pagedGenericFilterParamValues($paramId: Int, $name: String, $page: Int) {
    pagedGenericFilterParamValues(paramId: $paramId, name: $name, page: $page) {
      id
      name
    }
  }
`;
